import accountService from '@/api/accounts'
import errorhandler from '@/utils/errorhandler.js'
import utils from '@/utils/utils.js'
import { AUTH } from '../types'
import filedownloader from '@/utils/filedownloader.js'
import strings from '@/strings'

export default {
  namespaced: true,
  state: {
    isDownloadingFile: false,
    fileId: ''
  },
  mutations: {
    [AUTH.SET_IS_DOWNLOADING_FILE](state, value) {
      state.isDownloadingFile = value
    },
    [AUTH.SET_FILE_ID](state, fileId) {
      state.fileId = fileId
    }
  },
  actions: {
    async searchPaginated(_, payload) {
      try {
        const { page, size, search } = payload;

        const response = search ?
          await accountService.searchPaginatedByTerm(page, size, search) :
          await accountService.searchPaginated(page, size)

        return response.data
      } catch (error) {
        errorhandler.handleError(error)
      }
    },
    async getAccount(_, userId) {
      try {
        const response = await accountService.getAccount(userId)
        return response.data
      } catch (error) {
        errorhandler.handleError(error)
      }
    },
    async editAccount({ dispatch }, payload) {
      dispatch('Global/showLoading', null, { root: true })
      try {
        await accountService.editAccount(payload)
        dispatch('Global/showMessage', 'editUserSuccessfully', { root: true })
      } catch (error) {
        errorhandler.handleError(error)
      } finally {
        dispatch('Global/hideLoading', null, { root: true })
      }
    },
    async removeAccount({ dispatch }, userId) {
      try {
        dispatch('Global/showLoading', null, { root: true })
        await accountService.removeAccount(userId)
        dispatch('Global/showMessage', 'userSuccessfullyDeleted', { root: true })
      } catch (error) {
        errorhandler.handleError(error)
      } finally {
        dispatch('Global/hideLoading', null, { root: true })
      }
    },
    async resetPassword({ dispatch }, payload) {
      dispatch('Global/showLoading', null, { root: true })
      try {
        const { userId, passwordPayload } = payload
        await accountService.resetPassword(userId, passwordPayload)
        dispatch('Global/showMessage', 'resetPasswordSuccessfully', { root: true })
      } catch (error) {
        errorhandler.handleError(error)
        throw error
      } finally {
        dispatch('Global/hideLoading', null, { root: true })
      }
    },
    async saveAccount({ dispatch }, payload) {
      dispatch('Global/showLoading', null, { root: true })
      try {
        await accountService.saveAccount(payload)
        dispatch('Global/showMessage', 'addUserSuccessfully', { root: true })
      } catch (error) {
        errorhandler.handleError(error)
        throw error
      } finally {
        dispatch('Global/hideLoading', null, { root: true })
      }
    },
    async downloadAccountsTemplate({ dispatch }) {
      try {
        dispatch('setIsDownloadingFile', true)
        let response = await accountService.getAccountsTemplateFile()
        let contentType = response.headers['content-type']
        let contentDisposition = response.headers['content-disposition']
        let fileName = contentDisposition ? utils.getFileName(contentDisposition) : 'template_accounts.xlsx'

        let blob = new Blob([response.data], { type: contentType })
        utils.handleDownload(blob, fileName)
      } catch (error) {
        errorhandler.handleError(error)
      } finally {
        dispatch('setIsDownloadingFile', false)
      }
    },
    async downloadAccountsFile({ dispatch }) {
      await filedownloader.downloadFile(
        accountService.getAccountsFile.bind(accountService),
        'accounts.xlsx',
        null,
        dispatch,
      )
    },
    async saveFile({ dispatch }, file) {
      try {
        await accountService.importAccountsFile(file)
        return strings.uploadStatus.success
      } catch (error) {
        const errorResponse = error?.response
        const errorStatus = errorResponse?.status
        const errorReason = errorResponse?.data?.error?.message?.code
        const firstErrorMessage = errorResponse?.data?.error?.errors?.[0]?.message

        if (errorStatus === 422 && errorReason === 'importaccountsfilewithinvalidrows') {
          dispatch('setFileId', firstErrorMessage)
          return strings.uploadStatus.error
        }

        return strings.uploadStatus.waiting
      }
    },
    async getFileErrors({ state }) {
      let response = await accountService.getAccountsFileErrors(state.fileId)
      let contentType = response.headers['content-type']
      let blob = new Blob([response.data], { type: contentType })
      utils.handleDownload(blob, 'file-errors.xlsx')
    },
    setIsDownloadingFile({ commit }, value) {
      commit(AUTH.SET_IS_DOWNLOADING_FILE, value)
    },
    setFileId({ commit }, fileId) {
      commit(AUTH.SET_FILE_ID, fileId)
    }
  }
}
